<template>
  <div
    role="tooltip"
    class="tooltip-container"
    @mouseenter.prevent.stop="showTooltip"
    @focus.prevent.stop="showTooltip"
    @mouseleave.prevent.stop="hideTooltip"
    @blur.prevent.stop="hideTooltip"
  >
    <img src="@/assets/img/1x/ayuda.png" :alt="mensaje" ref="_tooltip" />
    <transition name="fade">
      <span class="tooltip" v-bind:class="orientation" v-if="show">
        {{ mensaje }}
      </span>
    </transition>
  </div>
</template>

<script>
export default {
  name: "HelpTooltip",
  props: {
    mensaje: {
      type: String,
      default: null
    }
  },
  data: () => {
    return {
      show: false,
      orientation: "left"
    };
  },
  methods: {
    showTooltip() {
      // Intentar ubicar de forma eficiente
      try {
        const rect = this.$refs._tooltip.getBoundingClientRect();
        const viewportW = window.innerWidth;
        if (rect.x + 203 >= viewportW) {
          this.orientation = rect.x >= 203 ? "top-left" : "top-right";
        } else {
          this.orientation = "left";
        }
        this.show = true;
      } catch {
        this.show = true;
      }
    },
    hideTooltip() {
      this.show = false;
    }
  }
};
</script>

<style scoped>
/* Container */
.tooltip-container {
  display: inline-block;
  vertical-align: middle;
  position: relative;
}

.tooltip-container img {
  display: block;
}

/* Tootlip */
.tooltip {
  position: absolute;
  /** Ubicar en la punta del triangulo */
  top: 8px;
  z-index: 100;
  background-color: #072146;
  text-align: left;
  color: white;
  font-family: "BentonSansBBVA-Light", Helvetica, Arial, sans-serif;
  font-weight: normal;
  font-size: 14px;
  line-height: 1.3em;
  white-space: normal;
  padding: 16px;
  /** El ancho está fijo */
  width: 195px;
  box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.3);
}

.tooltip::before {
  content: "";
  display: block;
  position: absolute;
  top: 0;
  width: 0;
  height: 0;
  border-style: solid;
}

.tooltip.left {
  left: 100%;
  left: calc(100% + 8px);
}

.tooltip.left::before {
  left: -8px;
  border-width: 0 8px 8px 0;
  border-color: transparent #072146 transparent transparent;
}

.tooltip.top-left {
  left: -160px;
  top: 30px;
}

.tooltip.top-left::before {
  top: -8px;
  left: 0;
  border-width: 8px 0px 0px 8px;
  border-color: transparent transparent transparent #072146;
}

.tooltip.top-right {
  left: -60px;
  top: 30px;
}

.tooltip.top-right::before {
  top: -8px;
  left: 0;
  border-width: 8px 0px 0px 8px;
  border-color: transparent transparent transparent #072146;
}

/* Transition */
.fade-enter-active,
.fade-leave-active {
  transition: all 0.5s;
  opacity: 1;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}
</style>
